import { NgClass } from "@angular/common";
import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "claas-empty-favorites-list",
  imports: [TranslatePipe, NgClass],
  templateUrl: "./empty-favorites-list.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./empty-favorites-list.scss",
})
export class EmptyFavoritesList {
  isAppPanel = input(false);
}
